import React, { useEffect } from "react";
import { useAuth } from "components/UseContext/authContext";

function Logout() {
  const { logout } = useAuth();

  useEffect(() => {
    logout();
  }, []);

  return <>Saliendo...</>;
}

export default Logout;
